// extracted by mini-css-extract-plugin
var _1 = "column-remove-padding__c7n28";
export { _1 as "columnRemovePadding" }
